import { motion } from 'framer-motion';
import { ArrowRight, Calendar } from 'lucide-react';
import { useLang } from '../../../context/LangContext';
import { GradientButton } from '../../shared/GradientButton';
import { GhostButton } from '../../shared/GhostButton';
import { fadeInUp } from '../../../animations/variants';

export const SecteursCTA = () => {
  const { t } = useLang();
  return (
    <section data-testid="secteurs-cta" className="relative py-24 md:py-32 bg-[#020209] overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(124,58,237,0.08),transparent_70%)]" />
      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
        <motion.h2 {...fadeInUp} className="text-3xl md:text-5xl font-bold text-white tracking-tight mb-4">
          {t("secteurs.cta.title")}
        </motion.h2>
        <motion.p {...fadeInUp} className="text-neutral-400 text-lg mb-10">
          {t("secteurs.cta.subtitle")}
        </motion.p>
        <motion.div className="flex flex-col sm:flex-row items-center justify-center gap-4"
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }}>
          <GradientButton href="/contact" data-testid="secteurs-cta-primary">
            <ArrowRight size={18} />{t("cta.primary")}
          </GradientButton>
          <GhostButton href="https://calendly.com/elite-help" external={true} data-testid="secteurs-cta-calendly">
            <Calendar size={18} />{t("cta.secondary")}
          </GhostButton>
        </motion.div>
      </div>
    </section>
  );
};
